<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="main">
    <div class="col-12">
        <h4 class="title-color">{{ 'setting.email_notifications' | translate }}</h4>
        <hr>
        <div class="row">
            <div class="col-12">
                <fieldset>   
                    <legend class="h5">{{'setting.email_language' | translate}}</legend>
                    <label class="radio-inline">
                        <input tabindex="0" id="EN" type="radio" name="optradio" (click)="setEmailLanguage('EN')">&nbsp; {{'setting.english' | translate}}
                    </label>&nbsp;
                    <label class="radio-inline">
                        <input tabindex="0" id="ES" type="radio" name="optradio" (click)="setEmailLanguage('ES')">&nbsp; {{'setting.spanish' | translate}}
                    </label>
                </fieldset>
            </div>
        </div>
    </div>
</div>
       